// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2btge","alert":"SettungsInbox_alert__3AZ5u"};